import * as React from 'react'

const TimerIcon = () => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.666992" width="32" height="32" rx="16" fill="#E4FBCC" />
      <path
        d="M16.6667 12V16L19.3333 17.3333M23.3333 16C23.3333 19.6819 20.3486 22.6666 16.6667 22.6666C12.9848 22.6666 10 19.6819 10 16C10 12.3181 12.9848 9.33331 16.6667 9.33331C20.3486 9.33331 23.3333 12.3181 23.3333 16Z"
        stroke="#66C61C"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default TimerIcon
